import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, BlockType, Define, ValidationMessage, TibboDataType, SettingOption, CodeBlock,
} from '@appblocks/codegeneration/types';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import General from '@appblocks/codegeneration/Features/General/General';
import PlatformUtils, { TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';

export default class MicroPythonGeneral extends BaseFeature {
    constructor() {
        super();
        this.name = 'General';
        this.id = 'general';

        this.files = [
            // '/.vscode/launch.json',
            // '/.vscode/extensions.json',
            // '/.vscode/tasks.json',
            // 'diagram.json',
            // 'wokwi.toml',
        ];

        const settings = [
            {
                id: 'DEVICE_NAME',
                name: 'Device Name',
                settingType: SettingType.STRING,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'GNAME',
                    NAME: 'Device Name',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MAX: 32,
                    DEFAULT: 'Device_Name_1',
                },
                UIControl: {
                    CONTROL: 'EDIT',
                },
                required: true,
                default: 'Device_Name_1',
                helpText: 'Give your device a name or link it to a setting.',
            },
            {
                id: 'FIRMWAREVERSION',
                name: 'Application Version',
                settingType: SettingType.STRING,
                required: true,
                default: '1.0.0',
                helpText: 'Your application\'s version number, which is shown in the Device Explorer.',
            },

            {
                id: 'TIMEZONE',
                name: 'Time Zone',
                settingType: SettingType.OPTION,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'TZONE',
                    NAME: 'Device Time Zone',
                    SETTINGTYPE: 'string',
                    MIN: 0,
                    MAX: 3,
                    DATATYPE: 'S',
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'UTC-12:00',
                            value: '0',
                        },
                        {
                            name: 'UTC-11:00',
                            value: '1',
                        },
                        {
                            name: 'UTC-10:00',
                            value: '2',
                        },
                        {
                            name: 'UTC-09:00',
                            value: '3',
                        },
                        {
                            name: 'UTC-08:00',
                            value: '4',
                        },
                        {
                            name: 'UTC-07:00',
                            value: '5',
                        },
                        {
                            name: 'UTC-06:00',
                            value: '6',
                        },
                        {
                            name: 'UTC-05:00',
                            value: '7',
                        },
                        {
                            name: 'UTC-04:30',
                            value: '8',
                        },
                        {
                            name: 'UTC-04:00',
                            value: '9',
                        },
                        {
                            name: 'UTC-03:30',
                            value: '10',
                        },
                        {
                            name: 'UTC-03:00',
                            value: '11',
                        },
                        {
                            name: 'UTC-02:00',
                            value: '12',
                        },
                        {
                            name: 'UTC-01:00',
                            value: '13',
                        },
                        {
                            name: 'UTC',
                            value: '14',
                        },
                        {
                            name: 'UTC+01:00',
                            value: '15',
                        },
                        {
                            name: 'UTC+02:00',
                            value: '16',
                        },
                        {
                            name: 'UTC+03:00',
                            value: '17',
                        },
                        {
                            name: 'UTC+03:30',
                            value: '18',
                        },
                        {
                            name: 'UTC+04:00',
                            value: '19',
                        },
                        {
                            name: 'UTC+04:30',
                            value: '20',
                        },
                        {
                            name: 'UTC+05:00',
                            value: '21',
                        },
                        {
                            name: 'UTC+05:30',
                            value: '22',
                        },
                        {
                            name: 'UTC+05:45',
                            value: '23',
                        },
                        {
                            name: 'UTC+06:00',
                            value: '24',
                        },
                        {
                            name: 'UTC+06:30',
                            value: '25',
                        },
                        {
                            name: 'UTC+07:00',
                            value: '26',
                        },
                        {
                            name: 'UTC+08:00',
                            value: '27',
                        },
                        {
                            name: 'UTC+09:00',
                            value: '28',
                        },
                        {
                            name: 'UTC+9:30',
                            value: '29',
                        },
                        {
                            name: 'UTC+10:00',
                            value: '30',
                        },
                        {
                            name: 'UTC+11:00',
                            value: '31',
                        },
                        {
                            name: 'UTC+12:00',
                            value: '32',
                        },
                        {
                            name: 'UTC+13:00',
                            value: '33',
                        },
                    ],
                },
                required: true,
                default: '0',
                options: [
                    {
                        name: 'UTC-12:00',
                        value: '0',
                    },
                    {
                        name: 'UTC-11:00',
                        value: '1',
                    },
                    {
                        name: 'UTC-10:00',
                        value: '2',
                    },
                    {
                        name: 'UTC-09:00',
                        value: '3',
                    },
                    {
                        name: 'UTC-08:00',
                        value: '4',
                    },
                    {
                        name: 'UTC-07:00',
                        value: '5',
                    },
                    {
                        name: 'UTC-06:00',
                        value: '6',
                    },
                    {
                        name: 'UTC-05:00',
                        value: '7',
                    },
                    {
                        name: 'UTC-04:30',
                        value: '8',
                    },
                    {
                        name: 'UTC-04:00',
                        value: '9',
                    },
                    {
                        name: 'UTC-03:30',
                        value: '10',
                    },
                    {
                        name: 'UTC-03:00',
                        value: '11',
                    },
                    {
                        name: 'UTC-02:00',
                        value: '12',
                    },
                    {
                        name: 'UTC-01:00',
                        value: '13',
                    },
                    {
                        name: 'UTC',
                        value: '14',
                    },
                    {
                        name: 'UTC+01:00',
                        value: '15',
                    },
                    {
                        name: 'UTC+02:00',
                        value: '16',
                    },
                    {
                        name: 'UTC+03:00',
                        value: '17',
                    },
                    {
                        name: 'UTC+03:30',
                        value: '18',
                    },
                    {
                        name: 'UTC+04:00',
                        value: '19',
                    },
                    {
                        name: 'UTC+04:30',
                        value: '20',
                    },
                    {
                        name: 'UTC+05:00',
                        value: '21',
                    },
                    {
                        name: 'UTC+05:30',
                        value: '22',
                    },
                    {
                        name: 'UTC+05:45',
                        value: '23',
                    },
                    {
                        name: 'UTC+06:00',
                        value: '24',
                    },
                    {
                        name: 'UTC+06:30',
                        value: '25',
                    },
                    {
                        name: 'UTC+07:00',
                        value: '26',
                    },
                    {
                        name: 'UTC+08:00',
                        value: '27',
                    },
                    {
                        name: 'UTC+09:00',
                        value: '28',
                    },
                    {
                        name: 'UTC+9:30',
                        value: '29',
                    },
                    {
                        name: 'UTC+10:00',
                        value: '30',
                    },
                    {
                        name: 'UTC+11:00',
                        value: '31',
                    },
                    {
                        name: 'UTC+12:00',
                        value: '32',
                    },
                    {
                        name: 'UTC+13:00',
                        value: '33',
                    },
                ],
            },
            {
                id: 'LOGGING',
                name: 'Debug Print Output',
                settingType: SettingType.OPTION,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'LOGGING',
                    NAME: 'Device Logging Method',
                    SETTINGTYPE: 'string',
                    MIN: 0,
                    MAX: 15,
                    DATATYPE: 'S',
                    DEFAULT: 'sys.debugprint',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'Console',
                            value: 'sys.debugprint',
                        },
                        {
                            name: 'Store in Logs',
                            value: 'tbl_log',
                        },
                        {
                            name: 'LCD',
                            value: 'lcd_log',
                        },
                    ],
                },
                required: true,
                default: '',
                options: [
                    {
                        name: 'Console',
                        value: 'sys.debugprint',
                    },
                ],
                helpText: 'Determines where log data are displayed.',
            },
            {
                id: 'BEEPFREQUENCY',
                name: 'Buzzer Frequency',
                settingType: SettingType.NUMBER,
                required: true,
                min: 2,
                max: 65535,
                default: '2700',
            },
            {
                id: 'LATITUDE',
                name: 'Latitude',
                settingType: SettingType.NUMBER,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'LAT',
                    NAME: 'Latitude',
                    SETTINGTYPE: 'float',
                    DATATYPE: 'B',
                    MIN: -90,
                    MAX: 90,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'EDIT',
                },
                required: true,
                min: -90,
                max: 90,
                default: '0',
            },
            {
                id: 'LONGITUDE',
                name: 'Longitude',
                settingType: SettingType.NUMBER,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'LNG',
                    NAME: 'Longitude',
                    SETTINGTYPE: 'float',
                    DATATYPE: 'B',
                    MIN: -180,
                    MAX: 180,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'EDIT',
                },
                required: true,
                min: -180,
                max: 180,
                default: '0',
            },
            {
                id: 'BAUD',
                name: 'Baud Rate',
                settingType: SettingType.HIDDEN,
                required: true,
                default: '115200',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        const { project } = this;
        if (settingId === 'LOGGING') {
            const options = [
                {
                    name: 'Console',
                    value: 'sys.debugprint',
                },
            ];
            const cgg = project.getFeature('cgg');
            if (cgg?.getSettingValue('ENABLED') === '1') {
                options.push({
                    name: 'Store in Logs',
                    value: 'tbl_log',
                });
            }
            return options;
        }
        return super.getSettingOptions(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const timezone = this.getSettingValue('TIMEZONE', true);

        blocks.push({
            location: 'MAIN',
            blockType: BlockType.CODE,
            template: `
#****loop****#`,
        });

        blocks.push({
            location: 'VARIABLE_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
APP_TIMEZONE=${timezone}`,
        });

        blocks.push({
            location: 'FUNCTION_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
def interface_set(interface, state):
    #****interface_set****#
    pass`,
        });

        // const fileCopyCommand = 'fs cp main.py :main.py';

        // blocks.push({
        //     location: 'VSCODE_UPLOAD_TASK',
        //     blockType: BlockType.CODE,
        //     template: fileCopyCommand,
        // });

        const boardType = PlatformUtils.getPlaformWokwiId(this.project.device.id);

        blocks.push({
            location: 'WOKWI_PARTS',
            blockType: BlockType.CODE,
            template: `
            {
                "type": "${boardType}",
                "id": "${boardType}",
                "top": 0,
                "left": 0,
                "attrs": {}
            },`,
        });

        return blocks;
    }
}
